cb.define([], function () { //编辑 新增 商品模板
  var AA_aa_custcategorylist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      viewmodel.on('beforeAdd', function (args) {
        if (args.params.params && args.params.params.cParameter == 'child'
          && args.params.parent) {
          if (args.params.parent.level > 4) {
            cb.utils.alert('分类最多支持5级，已达到最大级次。', 'warning');
            return false;
          }
          //增加子类
          args.params.carryParams.id = args.params.parent.id;
        }
      });

      viewmodel.on('beforeBatchdelete', function (args) {
        let node = viewmodel.getTreeModel().getSelectedNodes()[0];
        if (!node.isEnd) {
          cb.utils.alert('存在下级分类，不能删除。', 'warning');
          return false;
        }
        return true;
      });
      const setStatus = function(nodes, status){
        nodes.map(node => {
          if(node.level > 4){
            status.push({
              "key": node.id,
              "itemName": "btnAddChild",
              "name": "visible",
              "value": false
            });
          }
          if(!node.isEnd){
            status.push({
              "key": node.id,
              "itemName": "btnDelete",
              "name": "visible",
              "value": false
            });
          }

          if(!node.isEnabled){
            status.push({
              "key": node.id,
              "itemName": "btnAddChild",
              "name": "visible",
              "value": false
            });
          }

          if(node.children)
            setStatus(node.children, status)
        })
      }
      
      var treeModel = viewmodel.get('aa_custcategorylist');
      treeModel.on('afterSetDataSource', function (data) {
        let status = []
        setStatus(data, status);
        treeModel.setActionsState(status);
      })
    }
  }
  try {
    module.exports = AA_aa_custcategorylist_VM_Extend;
  } catch (error) {

  }
  return AA_aa_custcategorylist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_custcategorylist_VM.Extend.js